import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../__styling'
import { SubHeadingElements } from '../../typography/Subhead/Subhead'

export interface StyledHeaderProps {
    textCenter?: boolean
    specificFontSize?: number
    hasBackground?: boolean
    borderWidth?: number
}

export const StyledHeader = (hSize: SubHeadingElements) =>
    styled(hSize)<StyledHeaderProps>(
        ({
            theme,
            textCenter,
            specificFontSize,
            hasBackground,
            borderWidth,
        }) => [
            {
                textAlign: textCenter ? 'center' : 'initial',
                fontSize: calcRem(specificFontSize || 17),
                fontWeight: 900,
                paddingBottom: calcRem(10),
                display: 'inline-block',
                borderBottom: `${calcRem(2)} solid ${
                    tokens.sevennews.colors.palette.black
                }`,
                paddingRight: calcRem(30),
            },
        ],
    )
